function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.648 3.57L19.025.173c-.78-.469-1.788.076-1.788.965v5.885c0 .394.209.758.552.965l3.428 2.073 1.37.826c.749.454.42 1.577-.463 1.577h-3.72c-.645 0-1.17.51-1.17 1.138v6c0 2.633-2.328 4.743-5.084 4.492-2.4-.222-4.187-2.276-4.187-4.623V4.536c0-.394-.209-.759-.552-.965L1.787.172C1.007-.297 0 .248 0 1.142v5.884c0 .394.208.758.552.965l3.427 2.072 1.37.826c.75.455.421 1.578-.463 1.578H1.17C.525 12.47 0 12.977 0 13.608v5.73c0 6.67 5.365 12.317 12.22 12.516 7.121.207 12.98-5.37 12.98-12.253V4.536c0-.39-.208-.759-.552-.965z",
  fill: "#fff"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.b4af46fc.svg";
export { ForwardRef as ReactComponent };